export function getMinY(data: any[]): number {
    return data.reduce((min, p) => p.y < min ? p.y : min, data[0].y);
}
